import React from 'react';

import MerchantSelect from '@components/operator/MerchantSelect';
import { useOperatorData } from '@contexts/operator/OperatorDataContext';
import BrandEdit from '@shared/brands/BrandEdit';

import brandService from '@services/operator/brandService';

const BrandNewContent: React.FC = () => {
  const { merchants } = useOperatorData() as { merchants: Array<{ id: string; name: string }> };

  return (
    <BrandEdit
      brandService={brandService}
      role="operator"
      merchants={merchants}
    />
  );
};

const OperatorBrandNew: React.FC = () => {
  return (
    <MerchantSelect>
      <BrandNewContent />
    </MerchantSelect>
  );
};

export default OperatorBrandNew;
